function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.5365 0 0 1.5385 -.45052 -3.0769)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 8,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 8,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 8,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 8,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 8,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1,2 5.5,6 10,2 Z M 7.37,3 5.5,4.662 3.63,3 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "5.5 11 1 15 10 15"
}));

var SvgFlipV = function SvgFlipV(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlipV, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flip-v.315e1564.svg";
export { ForwardRef as ReactComponent };